import React, { useContext, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import MainContent from './MainContent';
import AlertListModal from '../AlertListModal';
import { AlertContext } from '../../alerts/AlertContext';

function Layout({ children }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const {
    alerts,
    error: alertsError,
    isLoading: alertsLoading,
    isAlertsModalOpen,
    closeAlertsModal,
  } = useContext(AlertContext);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);
  const onCloseSidebar = () => setSidebarOpen(false);

  return (
    <div className="min-h-screen bg-gray-100">
      <a
        href="#main-content"
        className="sr-only focus:not-sr-only focus:absolute focus:z-[100] focus:top-2 focus:left-2 focus:px-4 focus:py-2 focus:bg-white focus:text-primary-600 focus:ring-2 focus:ring-primary-500 focus:rounded focus:shadow-lg"
      >
        Skip to main content
      </a>
      <Header onToggleSidebar={toggleSidebar} />
      {isAlertsModalOpen && (
        <AlertListModal
          alerts={alerts}
          onClose={closeAlertsModal}
          isLoading={alertsLoading}
          error={alertsError}
        />
      )}

      <div className="flex min-h-[calc(100dvh-4rem)]">
        <Sidebar isOpen={sidebarOpen} onClose={onCloseSidebar} />

        <div className="flex flex-col flex-1 overflow-hidden">
          <MainContent>{children}</MainContent>
        </div>
      </div>
    </div>
  );
}

export default Layout;
